function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#94C11F",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M81.089 28.638L89.089 28.638 89.089 36.03",
  transform: "translate(-989 -228) translate(990.64 229.5) scale(1 -1) rotate(-32 -27.674 0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 31.656c22.091 3.875 47.287 2.819 59.36-2.235C73.642 23.443 82.475 13.636 85.86 0",
  transform: "translate(-989 -228) translate(990.64 229.5) matrix(1 0 0 -1 0 34)"
}))));

var SvgArrowSoils = function SvgArrowSoils(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 42,
    viewBox: "0 0 95 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowSoils, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowSoils.66d5d0f9.svg";
export { ForwardRef as ReactComponent };